import React, { useState } from "react";
import BG from "../../assets/hero-bg.jpg";

const ContactFormSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    alert("Thank you! Your message has been sent.");
    // Handle API submission here
  };

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <form id="contact-form" onSubmit={handleSubmit} className="w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 bg-white shadow-2xl rounded-2xl overflow-hidden">
            {/* --- Left Column: Image & Contact Info --- */}
            <div className="relative h-full min-h-[500px] lg:min-h-auto bg-slate-900 lg:rounded-l-2xl rounded-t-2xl lg:rounded-tr-none">
              {/* Background Image */}
              <img
                src={BG}
                alt="Office Background"
                className="absolute inset-0 w-full h-full object-cover opacity-80 mix-blend-multiply"
              />

              {/* Overlay Text: Contact Us */}
              <div className="absolute top-10 left-10 lg:top-12 lg:left-12 z-10">
                <h1 className="text-4xl font-extrabold text-white leading-tight">
                  Contact us
                </h1>
              </div>

              {/* Floating Card: Contact Details */}
              <div className="absolute bottom-0 w-full p-6 lg:p-12">
                <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 lg:p-8 text-white">
                  {/* Phone */}
                  <div className="flex items-center mb-6">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        ></path>
                      </svg>
                    </div>
                    <h5 className="text-lg font-medium ml-4 tracking-wide">
                      +93 78 841 4348
                    </h5>
                  </div>

                  {/* Email */}
                  <div className="flex items-center mb-6">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        ></path>
                      </svg>
                    </div>
                    <h5 className="text-lg font-medium ml-4 tracking-wide">
                      contact@yarqintechhub.com
                    </h5>
                  </div>

                  {/* Location */}
                  <div className="flex items-center">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        ></path>
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                      </svg>
                    </div>
                    <h5 className="text-lg font-medium ml-4 tracking-wide">
                      Mazar-e-Sharif, Afghanistan
                    </h5>
                  </div>
                </div>
              </div>
            </div>

            {/* --- Right Column: Contact Form --- */}
            <div className="bg-slate-50 p-6 lg:p-12 lg:rounded-r-2xl rounded-b-2xl lg:rounded-bl-none">
              <h2 className="text-3xl lg:text-4xl font-extrabold text-blue-600 mb-8">
                Send Us A Message
              </h2>

              {/* Input Fields */}
              <div className="space-y-6">
                {/* Name Input */}
                <div>
                  <label htmlFor="name" className="sr-only">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    required
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full h-12 text-slate-600 placeholder-slate-400 bg-white text-base font-normal leading-7 rounded-full border border-slate-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 pl-5 shadow-sm transition-all"
                  />
                </div>

                {/* Email Input */}
                <div>
                  <label htmlFor="email" className="sr-only">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    required
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full h-12 text-slate-600 placeholder-slate-400 bg-white text-base font-normal leading-7 rounded-full border border-slate-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 pl-5 shadow-sm transition-all"
                  />
                </div>

                {/* Phone Input */}
                <div>
                  <label htmlFor="phone" className="sr-only">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    id="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full h-12 text-slate-600 placeholder-slate-400 bg-white text-base font-normal leading-7 rounded-full border border-slate-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 pl-5 shadow-sm transition-all"
                  />
                </div>

                {/* Message Textarea */}
                <div>
                  <label htmlFor="message" className="sr-only">
                    Your Message
                  </label>
                  <textarea
                    name="message"
                    id="message"
                    rows="4"
                    required
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full text-slate-600 placeholder-slate-400 bg-white text-base font-normal leading-7 rounded-3xl border border-slate-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 p-5 shadow-sm transition-all resize-none"
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full h-12 text-white text-base font-bold leading-6 rounded-full transition-all duration-300 hover:bg-blue-700 bg-blue-600 shadow-lg hover:shadow-blue-500/30"
                >
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactFormSection;
